"use client";

import Image from "next/image";
import { useRouter, useParams } from "next/navigation";
import "./NewsGridStyle.css";
import moment from "moment";
import useTranslation from "@/hook/useTranslation";

const placeholderImage =
  "https://dummyimage.com/300x200/cccccc/ffffff&text=No+Image";

export default function NewsGrid({ news = [] }) {
  const router = useRouter();
  const { locale, t } = useTranslation();

  const sortedNews = [...news].sort(
    (a, b) => new Date(b.published_at) - new Date(a.published_at)
  );

  return (
    <div className="news-wrapper">
      <h2 style={{ textAlign: "center", marginBottom: "20px", color: "black" }}>
        {t("lastestNews")}
      </h2>

      {/* ✅ Featured News (Top 2) */}
      <div className="featured-news-grid">
        {sortedNews.slice(0, 2).map((item) => (
          <div
            key={item.id}
            className="featured-news-card hoverable"
            onClick={() => router.push(`/${locale}/news/${item.id}`)}
          >
            <Image
              src={item.image_url || placeholderImage}
              alt={item.title}
              width={500}
              height={300}
              className="news-image"
              unoptimized
            />
            <div className="news-content">
              <div className={`news-tag tag-${item.category.toLowerCase()}`}>
                {item.category}
              </div>

              <h3>{item.title}</h3>
              <p className="news-date">
                📅{" "}
                {moment(item.published_at, "YYYYMMDDTHHmmss").format(
                  "MMMM D, YYYY h:mm A"
                )}
              </p>
              <p>{item.description}</p>
              <span className="read-more">{t("readMore")}</span>
            </div>
          </div>
        ))}
      </div>

      {/* ✅ Grid News */}
      <div className="news-grid-centered">
        {sortedNews.slice(2, 14).map((item) => (
          <div
            key={item.id}
            className="news-card hoverable"
            onClick={() => router.push(`/${locale}/news/${item.id}`)}
          >
            <Image
              src={item.image_url || placeholderImage}
              alt={item.title}
              width={300}
              height={200}
              className="news-image"
              unoptimized
            />
            <div className="news-content">
              <div className={`news-tag tag-${item.category.toLowerCase()}`}>
                {item.category}
              </div>

              <h3>{item.title}</h3>
              <p className="news-date">
                📅{" "}
                {moment(item.published_at, "YYYYMMDDTHHmmss").format(
                  "MMMM D, YYYY h:mm A"
                )}
              </p>
              <p>{item.description}</p>
              <span className="read-more">{t("readMore")}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
